import type { CmsEventCategoryRecord } from './types';

const data: CmsEventCategoryRecord[] = [
	{
		id: 'arena-events',
		status: 'published',
		sort: null,
		listing_mode: 'visible_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Arena-Events',
				description: null,
				meta_description: null
			}
		],
		header_image: null
	},
	{
		id: 'events',
		status: 'published',
		sort: null,
		listing_mode: 'visible_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Events',
				description: null,
				meta_description: null
			}
		],
		header_image: null
	},
	{
		id: 'musik',
		status: 'published',
		sort: null,
		listing_mode: 'visible_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Musik',
				description: null,
				meta_description: null
			}
		],
		header_image: null
	},
	{
		id: 'entertainment',
		status: 'published',
		sort: null,
		listing_mode: 'visible_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Entertainment',
				description: null,
				meta_description: null
			}
		],
		header_image: null
	},
	{
		id: 'fanclub-heimspielanfragen',
		status: 'published',
		sort: null,
		listing_mode: 'hidden_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Fanclub - Heimspielanfragen',
				description: null,
				meta_description: null
			}
		],
		header_image: null
	},
	{
		id: 'fanclub-auswaertsanfragen',
		status: 'published',
		sort: null,
		listing_mode: 'hidden_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Fanclub - Auswärtsanfragen',
				description: null,
				meta_description: null
			}
		],
		header_image: null
	},
	{
		id: 'auswaerts',
		status: 'published',
		sort: null,
		listing_mode: 'hidden_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Auswärts',
				description: null,
				meta_description: ' '
			}
		],
		header_image: null
	},
	{
		id: 'heimspiele',
		status: 'published',
		sort: null,
		listing_mode: 'visible_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Heimspiele',
				description: null,
				meta_description: null
			},
			{
				languages_code: 'en-US',
				title: 'Home games',
				description: null,
				meta_description: null
			}
		],
		header_image: null
	},
	{
		id: 'sport',
		status: 'published',
		sort: null,
		listing_mode: 'visible_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Sport',
				description: null,
				meta_description: null
			}
		],
		header_image: null
	},
	{
		id: 'mitgliederversammlung-2024',
		status: 'published',
		sort: null,
		listing_mode: 'hidden_only',
		header_image_url: null,
		header_image_on_landing_page: false,
		translations: [
			{
				languages_code: 'de-DE',
				title: 'Mitgliederversammlung 2024',
				description: null,
				meta_description: null
			}
		],
		header_image: null
	}
];

export default data;
